import mock from "./mock"
import "./submission/submissions"
import "./search/search-result"

mock.onAny().passThrough()
